import { createRoot } from 'react-dom/client';

export const BREADCRUMB =
	document.getElementById('breadcrumbs') &&
	createRoot(document.getElementById('breadcrumbs'));
export const PROMOMSG = 
	document.getElementById('promoMsg') && 
	createRoot(document.getElementById('promoMsg'))
export const POPULARPACKAGE =
	document.getElementById('popularPackage') &&
	createRoot(document.getElementById('popularPackage'));
export const HEROBANNER =
	document.getElementById('heroBanner') &&
	createRoot(document.getElementById('heroBanner'));
export const FILTERCOLCATALOG =
	document.getElementById('filterColCatalog') &&
	createRoot(document.getElementById('filterColCatalog'));
export const PACKAGEGRID =
	document.getElementById('packageGrid') &&
	createRoot(document.getElementById('packageGrid'));
export const PAGETITLE =
	document.getElementById('pageTitle') &&
	createRoot(document.getElementById('pageTitle'));
export const HELPBUTTON =
	document.getElementById('helpButton') &&
	createRoot(document.getElementById('helpButton'));
